import { useMemo } from 'react';

// Helper to create stable field configs in parent components
export const useStableFieldsConfig = (config: any[]): any[] => {
  return useMemo(() => {
    // Create a deep copy and freeze each field to prevent mutations
    const stableConfig = config.map(field => Object.freeze({ ...field }));
    return stableConfig; // Return as mutable array type
  }, [
    // Only re-create if the shape or content actually changes
    config.length,
    ...config.map(field => field.key),
    ...config.map(field => field.label),
    ...config.map(field => field.type),
  ]);
};
